export interface AppSpecs {
  'specs.funnel.StudioTemplatesNewMarketplaceFooter': 'true' | 'false';
  'specs.funnel.StudioTemplatesMegaMenuNewUiV3': 'true' | 'false';
}

export const defaultAppSpecValues: AppSpecs = {
  'specs.funnel.StudioTemplatesNewMarketplaceFooter': 'false',
  'specs.funnel.StudioTemplatesMegaMenuNewUiV3': 'false',
};
